export default __webpack_public_path__ + "static/media/8.62150b29.pdf";